import React from 'react';
import Link from 'next/link';
import { ArrowUpRightIcon } from '@heroicons/react/16/solid';

interface BlockchainExplorerLinkProps {
  address: string;
}

const BlockchainExplorerLink: React.FC<BlockchainExplorerLinkProps> = ({ address }) => {
  const blockchainUrl = process.env.NEXT_PUBLIC_BLOCKCHAIN_URL;
  const etherscanUrl = `${blockchainUrl}${address}`;

  return (
    <Link
      href={etherscanUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center whitespace-nowrap"
    >
      <ArrowUpRightIcon className="inline-block ml-1 w-4 h-4 text-light" />
    </Link>
  );
};

export default BlockchainExplorerLink;
